kombi.toast = function (toastId) {
    const toast = document.getElementById(toastId);
    if (!toast) return;
    toast.classList.remove("d-none");
    setTimeout(() => {
        toast.classList.add("d-none");
    }, 5000);
};